import {  Navigate  } from 'react-router-dom'
import { isCorporateLoggedIn } from './utils';
import { CORPORATE_LOGIN } from './app/constant/userType';

export default function PrivateCorporateRoute({ component: Component, ...rest }) {

    let isLogged = false;
    const checkAuth = () => {
        return isCorporateLoggedIn(CORPORATE_LOGIN);
    }

    if(checkAuth()) {
        isLogged = true;
        localStorage.setItem("userType", CORPORATE_LOGIN);
    }
    // If authorized, return an outlet that will render child elements
    // If not, return element that will navigate to login page
    return isLogged ? <Component /> : <Navigate to="/" />;
}